import React from 'react'
import Button from '@components/Button'
import {useClearTable} from '@hooks/useClearTable'
import useSessionStorageState from '@hooks/useSessionStorageState'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

const OptionsTableServe = props => {
  const [onTable] = useSessionStorageState('onTable')
  const {preferences} = props
  const {t} = useTranslation('website', {keyPrefix: 'order.options.optionsTableServe'})
  const {clearTable} = useClearTable()

  if (onTable) return null

  return (
    <div className={styles.changeTableContainer}>
      <p>
        Estás en la <b>Mesa {preferences.tableName}</b>
        {preferences.store && preferences.store.name !== '' && (
          <span>
            {' '}
            del <b>Local {preferences.store.name}</b>
          </span>
        )}
      </p>
      <Button onClick={() => clearTable()}>{t('buttonChangePreferences')}</Button>
    </div>
  )
}

export default OptionsTableServe
